import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import { Form, InputGroup } from "react-bootstrap";
import moment from "moment/moment";




export default function CreatePricingContract() {
    const params = useParams();
    const [searchParams] = useSearchParams();

    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({  });
    const [form, setForm] = useState({
        productId: params.productId ?? 0,
        customerId: params.customerId ?? 0,
        costPriceSummer: 0,
        costPriceWinter: 0,
        salePriceSummer: 0,
        salePriceWinter: 0,
        haulageRateSummer: 0,
        haulageRateWinter: 0,
        tonnageAllowed: 0,
        tonnageUsed: 0,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: "",
        isActive: true
    });
    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);


    const [suppliers, setSuppliers] = useState([]);
    const [products, setProducts] = useState([]);
    const [customers, setCustomers] = useState([]);

    


    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    // Load the suppliers for the supplier dropdown
    useEffect(() => {

        // Load Suppliers
        axios.get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                
                if (res.status === 200) {
                    setSuppliers(res.data);
                }
            }).catch((err) => {
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            })

        // Load Customers
        axios.get(`https://${process.env.REACT_APP_IP}/api/customers/`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {

                if (res.status === 200) {
                    setCustomers(res.data);
                }
            }).catch((err) => {
                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            })

        // if any params were passed - set them now so they are selected in the dropdowns
        if (searchParams.get('supplierId')) {
            setForm((prevForm) => ({
                ...prevForm,
                supplierId: searchParams.get('supplierId')
            }));
        }
        if (searchParams.get('customerId')) {
            setForm((prevForm) => ({
                ...prevForm,
                customerId: searchParams.get('customerId')
            }));
        }
    }, [])

    // Load products
    useEffect(() => {
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/products?supplierId=${form.supplierId}`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                if (res.status === 200) {
                    setProducts(res.data.data);
                }
            })
    }, [form.supplierId])

    useEffect(() => {

        if (products && products.length > 0 && searchParams.get('productId')) {
            setForm((prevForm) => ({
                ...prevForm,
                productId: searchParams.get('productId')
            }));
        }

    }, [products]);

    // Is Valid changed - submit form
    useEffect(() => {
        
        if (isValid) {
            console.log("submitting...", isValid)
            setSubmitting(true);

            // Clear out the value for EndDate if its blank. It should submit null instead of a blank string
            if (form.endDate === "") {
                form.endDate = null;
            }

            axios
                .post(`https://${process.env.REACT_APP_IP}/api/pricingcontracts/`, form, { headers: { Authorization: `bearer ${user.token}` } })
                .then((res) => {
                    console.log("response:", res);
                    setSubmitting(false);

                    if (res.status === 200) {
                        navigate(`/Products/View/${res.data.product.id}`)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data);
                    setSubmitting(false);



                    if (err.code === "ERR_NETWORK") {
                        setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                    }
                    else if (err.code === "ERR_BAD_REQUEST") {
                        setFormErrors(err.response.data.errors);
                    }
                    else {
                        setFormErrors({ general: "An unknown error occured. " + err.code });
                    }
                });
        }
    }, [isValid]);

    useEffect(() => {
        console.log("formErrors changed", formErrors)
        setIsValid(formErrors.productId === "" && formErrors.customerId === "")
    }, [formErrors])

    // Product selected - pre-load the default prices for the product
    useEffect(() => {

        if (form.productId && form.productId != 0) {
            // get the selected product from the products list
            const selectedProduct = products.find((p) => p.id == form.productId);

            // update the form with the default prices for the product
            setForm({
                ...form,
                salePriceSummer: selectedProduct.salePriceSummer,
                salePriceWinter: selectedProduct.salePriceWinter,
                costPriceSummer: selectedProduct.costPriceSummer,
                costPriceWinter: selectedProduct.costPriceWinter,
                haulageRateSummer: selectedProduct.haulageRateSummer,
                haulageRateWinter: selectedProduct.haulageRateWinter
            });
        }


    }, [form.productId])

    const handleSubmit = (event) => {
        console.log("handle submit", form)
        event.preventDefault();

        setFormErrors({
            productId: form.productId === undefined || form.productId === 0 ? "Product is required" : "",
            customerId: form.customerId === undefined || form.customerId === 0 ? "Customer is required" : ""
        });
    }

    return (
        <div className="page">

            {submitting && (
                <SubmittingDialog />
            )}

            <div className="row">
                <div className="col-12">
                    <h1>
                      Create Pricing Contract
                    </h1>
                </div>
            </div>

            <Form onSubmit={handleSubmit} noValidate >

            
                <div className="row">
                    {/* Contact Details */}
                        <div className="col-md-6">

                        <div className="row">
                            <div className="col-md-12">
                                <h3>Contract Details</h3>
                            </div>
                        </div>

                   
                        <div className="row">
                            <div className="col-md-12">
                            

                            

                                { /* Supplier */}
                                <div className="form-group">
                                    <label>Supplier</label>
                                    <div className="select">
                                            <Form.Select
                                                onChange={(e) => setField("supplierId", e.target.value)}
                                                isInvalid={formErrors && formErrors.supplierId}
                                                value={form && form.supplierId}
                                            >
                                            <option value="0" disabled>Please Select...</option>
                                            {suppliers && (suppliers.map((supplier) => {
                                                return <option key={supplier.id} value={supplier.id}>{supplier.name}</option>
                                            }))}
                                        </Form.Select>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.supplierId}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                { /* Products */}
                                <div className="form-group">
                                    <label>Products</label>
                                    <div className="select">
                                        <Form.Select
                                            onChange={(e) => setField("productId", e.target.value)}
                                            isInvalid={formErrors && formErrors.productId}
                                            value={form && form.productId}
                                        >
                                            <option value="0" disabled>Please Select...</option>
                                            {products && (products.map((product) => {
                                                return <option key={product.id} value={product.id}>{product.name}</option>
                                            }))}
                                        </Form.Select>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.productId}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                { /* Customer */}
                                <div className="form-group">
                                    <label>Customer</label>
                                    <div className="select">
                                        <Form.Select
                                            onChange={(e) => setField("customerId", e.target.value)}
                                            isInvalid={formErrors && formErrors.customerId}
                                            value={form && form.customerId}
                                        >
                                            <option value="0" disabled>Please Select...</option>
                                            {customers && (customers.map((customer) => {
                                                return <option key={customer.id} value={customer.id}>{customer.name}</option>
                                            }))}
                                        </Form.Select>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.customerId}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                { /* Tonnage Allowed */}
                                <div className="form-group col-12">
                                    <label>Tonnage Allowed</label>
                                    <div className="col-4">
                                        <InputGroup>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g 79.99"
                                                isInvalid={formErrors && formErrors.tonnageAllowed}
                                                onChange={(e) => setField("tonnageAllowed", e.target.value)}
                                                value={form && form.tonnageAllowed}
                                            />
                                            <InputGroup.Text>Tonnes</InputGroup.Text> {/* Prefix */}
                                        </InputGroup>
                                    </div>
                                    <small>If this contract only covers a certain number of tonnes, enter the value here. The price contract will end when the allowance has been used. Otherwise, set to 0</small>
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        {formErrors.tonnageAllowed}
                                    </Form.Control.Feedback>
                                </div>

                                <div className="row g-0">
                                    { /* Start Date */}
                                    <div className="form-group col-6">
                                        <label>Start Date</label>
                                        <div className="col-12">
                                            <InputGroup>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    placeholder="e.g 01/01/2026"
                                                    isInvalid={formErrors && formErrors.startDate}
                                                    onChange={(e) => setField("startDate", e.target.value)}
                                                    value={form && moment(form.startDate).format('DD/MM/YYYY')}
                                                />
                                        
                                            </InputGroup>
                                        </div>
                                
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.startDate}
                                        </Form.Control.Feedback>
                                    </div>

                                    { /* End Date */}
                                    <div className="form-group col-6">
                                        <label>End Date</label>
                                        <div className="col-12">
                                            <InputGroup>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    placeholder="e.g 01/01/2026"
                                                    isInvalid={formErrors && formErrors.endDate}
                                                    onChange={(e) => setField("endDate", e.target.value)}
                                                    value={form && form.endDate && moment(form.endDate).format('DD/MM/YYYY')}
                                                />

                                            </InputGroup>
                                        </div>
                                
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.endDate}
                                        </Form.Control.Feedback>
                                        </div>

                                        <small>Enter the dates during which this price contract will apply. Leave the end date blank to keep the contract open permanently.</small>
                                </div>
                            </div>
                        
                        </div>

                    
                    </div>

                        {/* Pricing Details */}
                        <div className="col-md-6">

                            <div className="row">
                                <div className="col-12">
                                    <h3>Pricing Details</h3>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-6">

                                    { /* Cost Price */}
                                    <div className="form-group col-12">
                                        <label>Cost Price Summer</label>
                                        <InputGroup>
                                            <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g 79.99"
                                                isInvalid={formErrors && formErrors.costPriceSummer}
                                                onChange={(e) => setField("costPriceSummer", e.target.value)}
                                                value={form && form.costPriceSummer}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.costPriceSummer}
                                        </Form.Control.Feedback>
                                    </div>

                                    { /* Sale Price */}
                                    <div className="form-group col-12">
                                        <label>Sale Price Summer</label>
                                        <InputGroup>
                                            <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g 79.99"
                                                isInvalid={formErrors && formErrors.salePriceSummer}
                                                onChange={(e) => setField("salePriceSummer", e.target.value)}
                                                value={form && form.salePriceSummer}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.salePriceSummer}
                                        </Form.Control.Feedback>
                                    </div>

                                    { /* Haulage Rate */}
                                    <div className="form-group col-12">
                                        <label>Haulage Rate Summer</label>
                                        <InputGroup>
                                            <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g 79.99"
                                                isInvalid={formErrors && formErrors.haulageRateSummer}
                                                onChange={(e) => setField("haulageRateSummer", e.target.value)}
                                                value={form && form.haulageRateSummer}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.haulageRateSummer}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="col-6">
                                    { /* Cost Price */}
                                    <div className="form-group col-12">
                                        <label>Cost Price Winter</label>
                                        <InputGroup>
                                            <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g 79.99"
                                                isInvalid={formErrors && formErrors.costPriceWinter}
                                                onChange={(e) => setField("costPriceWinter", e.target.value)}
                                                value={form && form.costPriceWinter}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.costPriceWinter}
                                        </Form.Control.Feedback>
                                    </div>

                                    { /* Sale Price */}
                                    <div className="form-group col-12">
                                        <label>Sale Price Winter</label>
                                        <InputGroup>
                                            <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g 79.99"
                                                isInvalid={formErrors && formErrors.salePriceWinter}
                                                onChange={(e) => setField("salePriceWinter", e.target.value)}
                                                value={form && form.salePriceWinter}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.salePriceWinter}
                                        </Form.Control.Feedback>
                                    </div>

                                    { /* Haulage Rate */}
                                    <div className="form-group col-12">
                                        <label>Haulage Rate Winter</label>
                                        <InputGroup>
                                            <InputGroup.Text>&#163;</InputGroup.Text> {/* Prefix */}
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g 79.99"
                                                isInvalid={formErrors && formErrors.haulageRateWinter}
                                                onChange={(e) => setField("haulageRateWinter", e.target.value)}
                                                value={form && form.haulageRateWinter}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.haulageRateWinter}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>


                        </div>
                </div>
            


                <hr />

                {formErrors.general && (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-danger">
                                {formErrors.general}
                            </div>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-12">
                        <button className="btn btn-primary" type="submit">Create Contract</button>
                        <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(-1) }}>Cancel</button>
                    </div>
                </div>
            </Form>

        </div>
  )
}
